const SITE_ID = 28;const SITE_UID='2f909984-d18c-4a29-8d33-f526609187b6';const SUBDOMAIN='gyeongju';export { SITE_ID, SITE_UID, SUBDOMAIN }